import rootLogger from '@/utils/root-logger';
import windowUtils from '@/utils/window-utils';

const logger = rootLogger.create('store/modules/system');

export const BROWSER_CHECK_STATUS = {
  ok: 'ok',
  notOk: 'notOk',
  unknown: 'unknown'
};

// values should match os and browser names of
// https://www.npmjs.com/package/ua-parser-js
export const OS = {
  windows: 'Windows',
  mac: 'Mac OS',
  linux: 'Linux',
  ios: 'iOS',
  android: 'Android'
};
export const BROWSER = {
  chrome: 'Chrome',
  firefox: 'Firefox',
  safari: 'Safari',
  edge: 'Edge',
  ie: 'IE'
};

// minimum supported browser versions
// basically "last 3 versions of major browsers, plus IE 11"
// could be set at build time using browserslist?
export const MIN_BROWSERS = {
  [BROWSER.chrome]: 68,
  [BROWSER.firefox]: 60,
  [BROWSER.safari]: 10,
  [BROWSER.edge]: 16,
  [BROWSER.ie]: 11
};

const mutations = {
  setSupportedBrowsers(state, payload) {
    state.supportedBrowsers = payload.supportedBrowsers;
  },

  setBrowserCheckStatus(state, payload) {
    state.browserCheckStatus = payload.browserCheckStatus;
  }
};

const actions = {
  checkBrowser({ state, commit }, payload = {}) {
    const ua = windowUtils.getParsedUserAgent();
    logger.log('user agent', ua);

    let browserName = ua.browser.name;
    if (browserName === 'Mobile Safari') {
      browserName = BROWSER.safari;
    }
    const browserVersion = parseInt(ua.browser.major, 10);

    let browserCheckStatus = BROWSER_CHECK_STATUS.notOk;
    if (browserVersion >= state.supportedBrowsers[browserName]) {
      browserCheckStatus = BROWSER_CHECK_STATUS.ok;
    }

    if (!payload.preCheck) {
      commit('setBrowserCheckStatus', {browserCheckStatus});
    }

    return browserCheckStatus;
  }
};

const getters = {
  isBrowserSupported(state) {
    return state.browserCheckStatus === BROWSER_CHECK_STATUS.ok;
  }
};

export const getInitialSupportedBrowsers = () => {
  const {os} = windowUtils.getParsedUserAgent();
  let supportedBrowsers = {...MIN_BROWSERS};

  if (os.name === OS.ios) {
    // iOS: Safari
    supportedBrowsers = {
      [BROWSER.safari]: MIN_BROWSERS[BROWSER.safari]
    };
  } else if (os.name === OS.android) {
    // Android: Chrome
    supportedBrowsers = {
      [BROWSER.chrome]: MIN_BROWSERS[BROWSER.chrome]
    };
  } else if (os.name === OS.mac) {
    // Mac: Safari, Chrome, Firefox
    supportedBrowsers = {
      [BROWSER.safari]: MIN_BROWSERS[BROWSER.safari],
      [BROWSER.chrome]: MIN_BROWSERS[BROWSER.chrome],
      [BROWSER.firefox]: MIN_BROWSERS[BROWSER.firefox]
    };
  } else if (os.name === OS.windows) {
    // Windows: Chrome, Firefox, Edge, IE
    supportedBrowsers = {
      [BROWSER.chrome]: MIN_BROWSERS[BROWSER.chrome],
      [BROWSER.firefox]: MIN_BROWSERS[BROWSER.firefox],
      [BROWSER.edge]: MIN_BROWSERS[BROWSER.edge],
      [BROWSER.ie]: MIN_BROWSERS[BROWSER.ie]
    };
  }

  return supportedBrowsers;
};

const state = () => ({
  supportedBrowsers: getInitialSupportedBrowsers(),
  browserCheckStatus: BROWSER_CHECK_STATUS.unknown
});

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state
};
